<template>
  <div>
    <layout-label
      text="メールアドレス"
      icon="envelope-fill"
    />

    <b-form-group>
      <b-form-input
        type="email"
        v-model="model"
        placeholder="test@example.com">
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import LayoutLabel from '@/lib/Layout/Label'

export default {
  components: {
    LayoutLabel
  },

  data () {
    return {
      modelName: 'login',
      attribute: 'email'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
